<template>
  <div>
    <es-loader
      v-if="loading || loadingSavedData"
      style="margin-top: 3rem"
    />
    <template v-else>
      <es-form>
        <template #es-form>
          <div class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label
                  class="label"
                  style="width:230px"
                >
                  Person Type
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="buttons has-addons">
                      <button
                        v-for="(option, index) in sortedPersonTypesOptions"
                        :key="index"
                        class="button button--form"
                        :class="{ 'is-active': personType === option.code }"
                        @click="personType = option.code"
                        :disabled="!enabledSubmissionStatus.includes(option.code)"
                        style="min-width: 100px"
                      >
                        {{ option.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label
                  class="label"
                  style="width:230px"
                  :aria-label="getFieldLabel(`PER:${defaultPersonType}:SEARCH:DISTRICT_CODE`)"
                >
                  <span v-if="personType === null">
                    {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:DISTRICT_CODE`) }}
                  </span>
                  <span v-else>
                    {{ getFieldLabel(`PER:${personType}:SEARCH:DISTRICT_CODE`) }}
                  </span>
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <es-select
                      api="districts"
                      keyValue="code"
                      ref="selDistricts"
                      search-min-length="2"
                      @update:values="districts = $event"
                      :apiQueryParams="getAllDistricts"
                      :key="districtKey"
                      :preSelected="districts"
                      :search="true"
                      :valueTplFn="(result) => `${result.location.name} (${result.code})`"
                    />
                  </div>
                  <span
                    v-if="hasErrorDistricts"
                    class="help is-danger"
                  >
                    {{ msgDistrict }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label
                  class="label"
                  style="width:230px"
                  :aria-label="getFieldLabel(`PER:${defaultPersonType}:SEARCH:SCHOOL_CODE`)"
                >
                   <span v-if="personType === null">
                      {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:SCHOOL_CODE`) }}
                    </span>
                    <span v-else>
                      {{ getFieldLabel(`PER:${personType}:SEARCH:SCHOOL_CODE`) }}
                    </span>
                  <span class="label-optional has-text-grey-light">
                    &nbsp;(optional)
                  </span>
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <es-select
                      api="schools"
                      keyValue="code"
                      ref="resetSchool"
                      search-min-length="2"
                      @update:values="schools = $event"
                      :apiQueryParams="getDistrictParams"
                      :disabled="!districts.length"
                      :key="schoolKey"
                      :preSelected="schools"
                      :search="true"
                      :subValueTplFn="(result) =>
                        `${result.districtLocation.name} (<i>${result.districtCode}</i>)`"
                      :valueTplFn="(result) => `${result.location.name} (${result.code})`"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label
                  class="label"
                  style="width:230px"
                  :aria-label="getFieldLabel(`PER:${defaultPersonType}:SEARCH:ACTIVE`)"
                >
                   <span v-if="personType === null">
                      {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:ACTIVE`) }}
                    </span>
                    <span v-else>
                      {{ getFieldLabel(`PER:${personType}:SEARCH:ACTIVE`) }}
                    </span>
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="buttons has-addons">
                      <button
                        v-for="(option, index) in activeInactive"
                        style="width: 100px"
                        @click="active = option.code"
                        :key="index" class="button button--form"
                        :class="{ 'is-active': active === option.code }"
                      >
                        {{ option.description }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row removeUnderline">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label
                  class="label"
                  style="width:230px"
                  :aria-label="getFieldLabel(`PER:${defaultPersonType}:SEARCH:SCHOOL_YEAR`)"
                >
                  <span v-if="personType === null">
                    {{ getFieldLabel(`PER:${defaultPersonType}:SEARCH:SCHOOL_YEAR`) }}
                  </span>
                  <span v-else>
                    {{ getFieldLabel(`PER:${personType}:SEARCH:SCHOOL_YEAR`) }}
                  </span>
                  <span class="label-optional has-text-grey-light">
                    &nbsp;(optional)
                  </span>
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <es-select
                      key-value="id"
                      ref="resetSchoolYear"
                      value-tpl="${year}"
                      @update:values="schoolYearInput = $event"
                      :clearOut="true"
                      :key="preSelectedSchoolYear && preSelectedSchoolYear.length
                        ? preSelectedSchoolYear[0].id : null"
                      :preSelected="preSelectedSchoolYear"
                      :set-values="schoolYear"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </es-form>
      <div
        class="is-flex flex-justify--end flex-align--center"
        style="margin-right: 5.15rem; padding-bottom: 2rem"
      >
        <button
          class="button button-link has-underline"
          @click="reset"
          style="margin-right: 1rem"
        >
          Reset
        </button>
        <button
          class="button is-primary"
          @click="search"
          :disabled="loadingStudents"
        >
          Search
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import EsForm from '@/components/EsForm.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsSelect from '@/components/EsSelect.vue';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    FieldLabels,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsForm,
    EsLoader,
    EsSelect,
  },
  props: {
    // totalCount: {
    //   type: Number,
    //   default: null,
    // },
    page: {
      type: Number,
    },
    userDistrictInfo: {
      type: Array,
    },
    userSchoolInfo: {
      type: Array,
    },
    loadingStudents: {
      type: Boolean,
    },
  },
  data() {
    return this.initialData();
  },
  created() {
    this.setDataElements();
  },
  async mounted() {
    this.loading = true;
    this.loadingError = false;
    try {
      await Promise.all([
        this.loadPersonTypes(),
        this.loadPidSchoolYears(),
        this.loadSources(),
      ]);
      this.sourceInput = this.defaultSource;
      this.userPersonTypesCodes = this.userPersonTypes
        .map(item => item.code);
      this.personType = this.userPersonTypesCodes.includes(this.defaultPersonType)
        ? this.defaultPersonType : this.userPersonTypesCodes[0];
      this.loadSubmissionSpecs();
      this.searchType = 'newSearch';

      // Auto-execute search if searchByLocation state exists in Vuex
      const saved = this.$store.getters['personSearchModule/getSearchByType']('searchByLocation');
      if (saved && Object.keys(saved).length > 0) {
        this.loadingSavedData = true;
        this.$emit('show', false);
        this.$emit('loadingSavedData', true);
        // Populate fields from saved state
        this.personType = saved.personType || this.personType;
        if (saved.district) {
          const districtResponse = await this.$store.dispatch('getDistrict', saved.district);
          this.districts = [districtResponse.data];
          this.districtKey = saved.district;
        }
        if (saved.school && saved.district) {
          const schoolResponse = await this.$store.dispatch('getSchool', {
            districtCode: saved.district,
            schoolCode: saved.school,
          });
          this.schools = [schoolResponse.data];
          this.schoolKey = saved.school;
        } else {
          this.schools = saved.school ? [{ code: saved.school }] : this.schools;
        }
        this.active = saved.active !== undefined ? saved.active : this.active;
        // Handle schoolYear and schoolYearInput
        if (saved.schoolYear) {
          this.schoolYearInput = [{ year: saved.schoolYear }];
        } else {
          this.schoolYearInput = this.schoolYear.filter(y => y.year === this.currentSchoolYear);
        }
        this.loadingSavedData = false;
        this.$emit('loadingSavedData', false);
        this.search({ saveState: false, pageNum: saved.pageNum || null });
      } else {
        // No saved state, set schoolYearInput to current school year
        this.schoolYearInput = this.schoolYear.filter(y => y.year === this.currentSchoolYear);
        this.loadingSavedData = false;
      }
    } catch (err) {
      this.loadingError = true;
      this.messages.push('There were some errors. Please try again. If errors persist please contact support.');
      this.showNotification('danger', this.messages);
    } finally {
      this.loading = false;
    }
  },
  watch: {
    '$route.query.page': {
      handler(newPage) {
        const saved = this.$store.getters['personSearchModule/getSearchByType']('searchByLocation');
        if (saved && Object.keys(saved).length > 0) {
          this.$store.dispatch('personSearchModule/setSearchState', {
            searchType: 'searchByLocation',
            ...saved,
            pageNum: newPage ? Number(newPage) : null,
          });
        }
      },
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('lookups', [
      'activeSources',
      'pidSchoolYearsDesc',
      'defaultPersonType',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    allSubSpecsArray() {
      return [].concat(...this.allSubmissionSpecs);
    },
    currentSchoolYear() {
      return this.$store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'];
    },
    defaultSource() {
      if (this.activeSources) {
        const defaultType = this.activeSources
          .find(el => el.defaultType === true);
        return defaultType ? defaultType.code : this.activeSources[0].code;
      } return null;
    },
    enabledSubmissionStatus() {
      if (this.allSubSpecsArray) {
        return this.allSubSpecsArray
          .filter(d => d.purpose === 'SEARCH' && d.enabled === true)
          .map(p => p.personType.code);
      } return null;
    },
    getAllDistricts() {
      const params = {};
      params.active = 'all';
      return params;
    },
    getDistrictParams() {
      const params = {};
      params.districtCode = this.districts.map(d => d.code);
      params.active = 'all';
      return params;
    },
    preSelectedSchoolYear() {
      if (!this.schoolYearInput || !this.schoolYearInput[0]) {
        return [];
      }
      return this.schoolYear.filter(y => y.year === this.schoolYearInput[0].year);
    },
    sortedPersonTypesOptions() {
      const sorted = this.userPersonTypes.map(p => ({
        code: p.code,
        name: p.name,
      }));
      return sorted.slice().sort((a, b) => {
        if (a.name.toUpperCase() < b.name.toUpperCase()) {
          return -1;
        }
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
          return 1;
        }
        return 0;
      });
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadSources',
      'loadPersonTypes',
      'loadPidSchoolYears',
    ]),
    checkRequiredFields() {
      if (!this.districts.length) {
        this.hasErrorDistricts = true;
        this.msgDistrict = 'District is required.';
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
      } else {
        this.hasErrorDistricts = false;
        this.msgDistrict = null;
        this.resetNotifications();
      }
      return this.hasErrorDistricts;
    },
    flatten(obj) {
      const flattenedObject = {};
      this.traverseAndFlatten(obj, flattenedObject);
      return flattenedObject;
    },
    initialData() {
      return {
        active: null,
        allSubmissionSpecs: [],
        apiSorter: {},
        activeInactive: [],
        districtKey: null,
        districts: this.userDistrictInfo.length === 1 ? this.userDistrictInfo : [],
        hasErrorDistricts: null,
        loading: false,
        loadingError: false,
        loadingSavedData: true,
        loadingStudentsError: false,
        msgDistrict: null,
        personType: null,
        schoolKey: null,
        schools: this.userSchoolInfo.length === 1 ? this.userSchoolInfo : [],
        schoolYear: [],
        schoolYearInput: [],
        studentInfoRaw: [],
        studentInfoCleaned: [],
        totalCount: null,
        userPersonTypes: this.$store.state.user.userPersonTypes
          .map(item => item.personType).filter(a => a.status === true),
        userPersonTypesCodes: null,
      };
    },
    async loadSubmissionSpecs() {
      const personTypeIds = this.userPersonTypes.map(item => item.id);
      try {
        this.loading = true;
        this.loadingError = false;
        // build promises to get submission specs info per person type
        const submissionSpecResponse = await Promise.all([...personTypeIds]
          .map(id => axios.get(`person-types/${id}/submission-specs/`)));
        // use the response from above and push them
        submissionSpecResponse.forEach((s) => {
          this.allSubmissionSpecs.push(s.data);
        });
      } catch (err) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.personType = this.userPersonTypesCodes.includes(this.defaultPersonType)
        ? this.defaultPersonType : this.userPersonTypesCodes[0];
      this.active = null;
      if (this.userDistrictInfo.length !== 1) {
        this.$refs.selDistricts.clear();
      }
      if (this.userSchoolInfo.length !== 1 && this.schools.length) {
        this.$refs.resetSchool.clear();
      }
      this.$refs.resetSchoolYear.clear();
      this.$refs.resetSchoolYear.pushValues(this.schoolYear
        .filter(y => y.year === this.currentSchoolYear));
      this.$store.dispatch('personSearchModule/resetSearchState', 'searchByLocation');
      this.hasErrorDistricts = false;
      this.msgDistrict = null;
      this.resetNotifications();
      this.$emit('show', true);
      this.$emit('districtCode', null);
      this.$router.replace({ query: {} }).catch(() => { });
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    setSchoolYear() {
      this.schoolYear = this.pidSchoolYearsDesc;
      this.schoolYearInput = this.schoolYear.filter(y => y.year === this.currentSchoolYear);
    },
    search({ saveState = true, pageNum = null } = {}) {
      if (this.checkRequiredFields()) {
        return;
      }
      const { query } = this.$route;
      query.districts = this.districts[0].code;
      if (this.schools.length) {
        query.schools = this.schools[0].code;
      }
      query.active = this.active;
      if (saveState) {
        this.$store.dispatch('personSearchModule/setSearchState', {
          searchType: 'searchByLocation',
          district: this.districts[0].code,
          personType: this.personType !== null ? this.personType : null,
          school: this.schools.length ? this.schools[0].code : null,
          active: this.active !== null ? this.active : null,
          schoolYear: this.schoolYearInput.length
            ? this.schoolYearInput[0].year
            : this.schoolYear[0].year,
        });
      }
      this.$router.push(
        {
          name: 'PidSearchLocation',
          query: {
            district: this.districts[0].code,
            school: this.schools.length ? this.schools[0].code : undefined,
            active: this.active !== null ? this.active : undefined,
            schoolYear: this.schoolYearInput.length
              ? this.schoolYearInput[0].year
              : this.schoolYear[0].year,
            personType: this.personType !== null ? this.personType : undefined,
            page: pageNum || undefined,
          },
        },
      );
      this.urlParams();
      this.$emit('show', false);
      this.$emit('districtCode', this.districts[0].code);
    },
    setDataElements() {
      this.schoolYear = this.pidSchoolYearsDesc;
      // Don't set schoolYearInput here - it will be set in mounted after checking for saved data
      this.activeInactive = [
        {
          code: null,
          description: 'All',
        },
        {
          code: true,
          description: 'Active',
        },
        {
          code: false,
          description: 'Inactive',
        },
      ];
    },
    traverseAndFlatten(currentNode, target, flattenedKey) {
      Object.keys(currentNode).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(currentNode, key)) {
          let newKey;
          if (flattenedKey === undefined) {
            newKey = key;
          } else {
            newKey = `${flattenedKey}_${key}`;
          }
          const value = currentNode[key];
          if (typeof value === 'object') {
            this.traverseAndFlatten(value, target, newKey);
          } else {
            target[newKey] = value; // eslint-disable-line no-param-reassign
          }
        }
      });
    },
    urlParams() {
      const params = {};
      params.schoolCode = this.schools.length ? this.schools[0].code : undefined;
      params.active = this.active !== null ? this.active : undefined;
      params.schoolYear = this.schoolYearInput.length !== 0
        ? this.schoolYearInput[0].year : undefined;
      params.personType = this.personType !== null ? this.personType : undefined;
      this.$emit('searchParams', params);
      return params;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
